import axios from "axios";
import { RESTAURANT_ID, BASE_URL } from "../redux/constants/Constants";

export const cartAvailability = async (token, customer_id) => {
    const url = `${BASE_URL}/cart/?customer_id=${customer_id}&restaurant=${RESTAURANT_ID}`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `token ${token}`,
      },
    };
  
    try {
      const response = await axios.get(url, config);
      return response;
    } catch (error) {
      if (error.response) {
        return error.response;
      } else {
        console.error(error);
        return { status: 500, data: { message: error.message || "Request failed" } };
      }
    }
  };

  export const createCart = async (token, data) => {
    const url = `${BASE_URL}/cart/`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `token ${token}`,
      },
    };
  
    try {
      const response = await axios.post(url, data, config);
      return response;
    } catch (error) {
      if (error.response) {
        return error.response;
      } else {
        console.error("createCart API Error:", error.response?.data || error.message);
        return { status: 500, data: { message: error.message || "Request failed" } };
      }
    }
  };

  export const addToCart = async (token, data) => {
    const url = `${BASE_URL}/v2/cart-item-post/`;
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `token ${token}`,
      },
    };
  
    try {
      const response = await axios.post(url, data, config);
      return response;
    } catch (error) {
      if (error.response) {
        return error.response;
      } else {
        console.error("addToCart API Error:", error.response?.data || error.message);
        return { status: 500, data: { message: error.message || "Request failed" } };
      }
    }
  };

export const getCartItems = async (token, cartId) => {
  const url = `${BASE_URL}/v2/cart-items-x/?cart_id=${cartId}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch(error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
}

export const updateCartItems = async(token, data, cartItemId) => {
  const url = `${BASE_URL}/v2/cart-item-post/${cartItemId}/`;
  const config = {
    headers : {
      "Content-Type": "application/json",
      Authorization: `token ${token}`
    }
  }

  try {
    const response = await axios.put(url, data, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
} 

export const deleteCartItem = async(token, cartItemId) => {
 const url = `${BASE_URL}/cart-item-x/${cartItemId}/`;
 const config = {
    headers : {
      "Content-Type": "application/json",
      Authorization: `token ${token}`
    }
  }

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      console.error(error);
      return { status: 500, data: { message: error.message || "Request failed" } };
    }
  }
}

export const getFeatureFlags = async (restaurantId = RESTAURANT_ID) => {
  const url = `${BASE_URL}/feature-flags/?restaurant_id=${restaurantId}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching feature flags:", error);
    return null;
  }
};

export const toggleFeatureFlag = async (token, isEnabled = false, key = "b2g1_offer_enabled", restaurantId = RESTAURANT_ID || 1) => {
  const url = `${BASE_URL}/feature-flags/toggle/`;
  const config = {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `token ${token}` } : {}),
    },
  };

  const payload = {
    key: key,
    is_enabled: Boolean(isEnabled),
    restaurant_id: Number(restaurantId) || 1,
  };

  try {
    const response = await axios.post(url, payload, config);
    return response;
  } catch (error) {
    console.error("toggleFeatureFlag API Error:", error.response?.data || error.message);
    return { error: error.message };
  }
};

export const getActiveOffers = async (restaurantId = RESTAURANT_ID) => {
  const url = `${BASE_URL}/active-offers/?restaurant_id=${restaurantId}`;
  try {
    const response = await axios.get(url);
    const dataObj = response?.data?.data || response?.data?.results || response?.data || {};
    return {
      festival_offer_enabled: dataObj.festival_offer_enabled === true || dataObj.festival_offer_enabled === "true" || dataObj.festival_offer_enabled === 1,
      new_user_offer_enabled: dataObj.new_user_offer_enabled === true || dataObj.new_user_offer_enabled === "true" || dataObj.new_user_offer_enabled === 1,
      b2g1_offer_enabled: dataObj.b2g1_offer_enabled === true || dataObj.b2g1_offer_enabled === "true" || dataObj.b2g1_offer_enabled === 1,
      raw: dataObj,
    };
  } catch (error) {
    console.error("Error fetching active offers:", error?.response?.data || error.message);
    return {
      festival_offer_enabled: false,
      new_user_offer_enabled: false,
      b2g1_offer_enabled: false,
      error: error?.message || "Failed to fetch active offers",
    };
  }
};

export const isCouponEnabledByAdmin = (coupon, activeOffersData) => {
  if (!coupon) return false;

  // 1. Direct coupon status / active / disabled checks from backend DB object
  const rawStatus = coupon.status ?? coupon.coupon_status ?? coupon.state;
  if (rawStatus !== undefined && rawStatus !== null) {
    if (typeof rawStatus === "boolean") {
      if (!rawStatus) return false;
      if (rawStatus) return true;
    } else if (typeof rawStatus === "number") {
      if (rawStatus === 0) return false;
      if (rawStatus === 1) return true;
    } else if (typeof rawStatus === "string") {
      const s = rawStatus.trim().toLowerCase();
      if (
        s === "disabled" ||
        s === "inactive" ||
        s === "false" ||
        s === "0" ||
        s === "off" ||
        s === "deactivated"
      ) {
        return false;
      }
      if (
        s === "active" ||
        s === "enabled" ||
        s === "true" ||
        s === "1"
      ) {
        return true;
      }
    }
  }

  const rawActive = coupon.is_active ?? coupon.active ?? coupon.enabled;
  if (rawActive !== undefined && rawActive !== null) {
    if (
      rawActive === false ||
      rawActive === 0 ||
      rawActive === "false" ||
      rawActive === "0"
    ) {
      return false;
    }
    if (
      rawActive === true ||
      rawActive === 1 ||
      rawActive === "true" ||
      rawActive === "1"
    ) {
      return true;
    }
  }

  const rawDisabled = coupon.is_disabled ?? coupon.disabled;
  if (rawDisabled !== undefined && rawDisabled !== null) {
    if (
      rawDisabled === true ||
      rawDisabled === 1 ||
      rawDisabled === "true" ||
      rawDisabled === "1"
    ) {
      return false;
    }
    if (
      rawDisabled === false ||
      rawDisabled === 0 ||
      rawDisabled === "false" ||
      rawDisabled === "0"
    ) {
      return true;
    }
  }

  if (!activeOffersData) return true;

  const code = (coupon?.coupon_code || coupon?.code || "").toString().trim().toUpperCase();
  const name = (coupon?.name || coupon?.title || coupon?.coupon_title || "").toString().trim().toUpperCase();
  const type = (coupon?.coupon_type || coupon?.type || "").toString().trim().toUpperCase();

  // 2. Global Synthetic / Feature Flag Offers Check (for items without direct coupon status)
  const isFestival =
    code.includes("GANESH") ||
    code.includes("FESTIVAL") ||
    code.includes("DUSSEHRA") ||
    code.includes("DUSSEHARA") ||
    code.includes("DIWALI") ||
    name.includes("FESTIVAL") ||
    name.includes("GANESH") ||
    name.includes("DUSSEHRA") ||
    name.includes("DUSSEHARA") ||
    name.includes("DIWALI");

  if (isFestival && activeOffersData.festival_offer_enabled === false) {
    return false;
  }

  const isNewUser =
    code.includes("NEWUSER") ||
    code.includes("NEW_USER") ||
    name.includes("NEW USER") ||
    name.includes("NEWUSER");

  if (isNewUser && activeOffersData.new_user_offer_enabled === false) {
    return false;
  }

  const isB2G1 =
    type === "BOGO" ||
    code.includes("B2G1") ||
    code.includes("BOGO") ||
    code.includes("BUY2GET1") ||
    name.includes("B2G1") ||
    name.includes("BOGO") ||
    name.includes("BUY 2 GET 1");

  if (isB2G1 && activeOffersData.b2g1_offer_enabled === false) {
    return false;
  }

  return true;
};